module.exports = __webpack_public_path__ + "static/img/banner.f8a304f4.png";